import { render, staticRenderFns } from "./OptionUpdate.vue?vue&type=template&id=0cd6023c"
import script from "./OptionUpdate.vue?vue&type=script&lang=ts"
export * from "./OptionUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports